import React from 'react';
// nodejs library to set properties for components
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import Grid from '@mui/material/Grid';

const styles = {
  grid: {
    padding: '0 15px !important',
    margin: '0 auto',
  },
};

const useStyles = makeStyles(styles);

export default function GridsItem(props) {
  const classes = useStyles();
  const { children, ...rest } = props;
  return (
    <Grid item {...rest} className={classes.grid}>
      {children}
    </Grid>
  );
}

GridsItem.propTypes = {
  children: PropTypes.node,
};
